import React from 'react';
import PropTypes from 'prop-types';

const TimeLeft = ({
  estimatedTime,
  separator
}) => /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
  "data-test": "estimated-time"
}, estimatedTime), separator && /*#__PURE__*/React.createElement("span", {
  className: "slds-m-horizontal_x-small"
}, "\u2022"));
TimeLeft.displayName = "TimeLeft";
TimeLeft.propTypes = {
  estimatedTime: PropTypes.string.isRequired,
  separator: PropTypes.bool
};
TimeLeft.defaultProps = {
  separator: true
};
var TimeLeft$1 = TimeLeft;

export { TimeLeft$1 as default };
